import React    from 'react';
import ReactDOM from 'react-dom';
import App      from './App';
require( './scss/main.scss' );

ReactDOM.render( <App />, document.getElementById( 'portfolio' ));
